import React, { useState } from 'react'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import LiveModal from 'live/components/ui/Modal'

interface Props {
    onConfirm?(): void
    message?: string
    title?: string
    children: React.ReactNode
}

export function DuplicateButton({ onConfirm, title, children }: Props): JSX.Element {
    const [showModal, setShowModal] = useState<boolean>(false)

    return (
        <>
            <Container onClick={() => setShowModal(true)}>
                <StyledDuplicate className="far fa-clone" />
                <span>{title}</span>
            </Container>
            <LiveModal show={showModal} animation={false} className="modal-sm">
                <LiveModal.Header>
                    <LiveModal.Title>{title}</LiveModal.Title>
                </LiveModal.Header>
                <LiveModal.Body>{children}</LiveModal.Body>
                <LiveModal.Footer>
                    <LiveModal.ModalActions
                        onSubmit={() => {
                            onConfirm()
                            setShowModal(false)
                        }}
                        submitText={i18n('Duplicate')}
                        submitBtnClassName={'btn btn-primary'}
                        cancelBtnClassName={'btn btn-link'}
                        onCancel={() => setShowModal(false)}
                        cancelText={i18n('Cancel')}
                    />
                </LiveModal.Footer>
            </LiveModal>
        </>
    )
}

const Container = styled.div`
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: 'row';
    cursor: pointer;

    span {
        font-style: normal;
        font-size: 12px;
        line-height: 16px;
        color: ${({ theme }) => theme['blue-700']};
    }
`
export const StyledDuplicate = styled.i`
    font-family: Font Awesome 5 Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 40px;
    color: ${({ theme }) => theme['blue-700']};
    margin-right: 1rem;
`